import {IntegrationOption, IntegrationType} from 'types/integration';
import {
  GoogleDriveIcon,
  ShopifyBrandIcon,
} from 'pages/Settings/Integrations/icons';

export const INTEGRATION_OPTIONS: IntegrationOption[] = [
  {
    logo: <ShopifyBrandIcon width={120} height={120} />,
    company_name: 'Shopify',
    description:
      'Seamlessly bring your customers, orders, and products into the app by integrating your existing Shopify store.',
    url: 'https://www.shopify.com',
    integration_type: 'shopify',
    entities: ['customers', 'products', 'orders'],
  },

  {
    logo: <GoogleDriveIcon width={120} height={120} />,
    company_name: 'Google Drive',
    description:
      'Integrate Google Drive to enable uploading a large number of photos and videos from the Jobs app during order completion. By default, only one photo upload is allowed directly within the Jobs app.',
    url: 'https://www.google.com/drive',
    integration_type: 'google_drive',
    entities: [],
  },
];

export const INTEGRATIONS: Record<IntegrationType, IntegrationOption> = {
  shopify: {
    logo: <ShopifyBrandIcon width={120} height={120} />,
    company_name: 'Shopify',
    description:
      'Seamlessly bring your customers, orders, and products into the app by integrating your existing Shopify store.',
    url: 'https://www.shopify.com',
    integration_type: 'shopify',
  },
  google_drive: {
    logo: <GoogleDriveIcon width={120} height={120} />,
    company_name: 'Google Drive',
    description:
      'Integrate Google Drive to enable uploading a large number of photos and videos from the Jobs app during order completion. By default, only one photo upload is allowed directly within the Jobs app.',
    url: 'https://www.google.com/drive',
    integration_type: 'google_drive',
  },
};

export const INTEGRATION_OPTIONS_LABELS: Record<IntegrationType, string> = {
  shopify: 'Shopify',
  google_drive: 'Google Drive',
};
